import { configureStore } from '@reduxjs/toolkit';

import { APP_ENV } from '@/global/enums/common.enums';

import { middleware } from './middleware';
import { reducer } from './reducers';

export const makeStore = () => {
  const _store = configureStore({
    reducer,
    middleware: getDefaultMiddleware => getDefaultMiddleware({ serializableCheck: false }).concat(middleware),
    devTools: process.env.NEXT_PUBLIC_ENV !== APP_ENV.PROD,
  });

  return _store;
};
